// extracted by mini-css-extract-plugin
export default {"root":"ChatHeader_root__wTMHB","logoutIcon":"ChatHeader_logoutIcon__noi75"};